import React from 'react';
import { TextInput } from 'src/common/form/text-input';

interface Props {
  onUrlChange: (url: string) => void;
}

export const DashboardLibraryContentAddPanelLinkInput = ({ onUrlChange }: Props) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onUrlChange(event.target.value);
  };

  return (
    <TextInput
      id='create-content-input'
      inputClasses='pr-10'
      autoFocus
      onChange={handleInputChange}
      inputProps={{
        type: 'text',
        name: 'create-content-input',
        placeholder: 'Paste a URL or email',
      }}
    />
  );
};
